import React, { memo, useMemo } from "react";
import { LottieInfoLayoutCard } from "@swiggy-private/dls-react-mxn/dist/WidgetController/widgets/LottieInfoLayoutCard";
import { LottieWrapper } from "./styles";
import { getLottieInfoProp } from "./helpers";
import { DINE_CASH_POOLING_TEST_IDS } from "@dineout-cart-ui/helpers/TestIds";

interface IDineCashLottieProps {
    url: string;
    totalAmountReceived?: number;
    maxPoolAmountAllowed?: number;
    maxAmountReached?: boolean;
}

const DineCashLottie = ({
    url,
    totalAmountReceived,
    maxPoolAmountAllowed,
    maxAmountReached,
}: IDineCashLottieProps): JSX.Element | null => {
    const lottieProps = useMemo(
        () => getLottieInfoProp({ url, totalAmountReceived, maxPoolAmountAllowed, maxAmountReached }),
        [url, totalAmountReceived, maxPoolAmountAllowed, maxAmountReached],
    );

    if (!url) return null;

    return (
        <LottieWrapper data-testid={DINE_CASH_POOLING_TEST_IDS.LOTTIE}>
            <LottieInfoLayoutCard key={`${totalAmountReceived}-${url}`} {...lottieProps} />
        </LottieWrapper>
    );
};

export default memo(DineCashLottie);
